import i18n from "../locales/i18n";

import {
  AdSourceGroupEnum,
  CustomerHasOwnerEnum,
  DDTechTypeEnum,
  ExchangeRateUnitEnum,
  InfrastructureEnum,
  PasswordFrequencyEnum,
  SignitureTypeEnum,
  currencyEnum,
  invoicePeriodEnum,
  lineEnum,
  newTypeEnum,
  paymentTypeEnum,
  paymentVoiceTypeEnum,
  serviceConnectTypeEnum,
  serviceTypeEnum,
  termsOfPaymentInvoiceGroupEnum,
} from "./enum";

export const taxOptions = [
  { value: "1", label: "Damga Vergisi" },
  { value: "2", label: "Deneme 1" },
  { value: "3", label: "Deneme 2" },
];

export const paymentOptions = [
  { value: 1, label: "Tek Seferlik" },
  { value: 2, label: "Aylık" },
];

export const customerPaymentTypeOptions = [
  { value: 1, label: "UseAfterPay" },
  { value: 2, label: "PayAfterUse" },
];

export const documentserviceOptions = [
  { value: "1", label: "İşte Güvenlik" },
  { value: "2", label: "İşteHotspot" },
  { value: "3", label: "Metro Ethernet İnternet Al-Sat" },
];

export const brandOptions = [
  { value: "cisco", label: "Cisco" },
  { value: "checkpoint", label: "Check Point" },
];

export const variantOptions = [
  { value: "speed", label: "Hız" },
  { value: "qota", label: "Kota" },
];

export const speedOptions = [
  { value: 0, label: "10Mb" },
  { value: 1, label: "100Mb" },
];

export const qotaOptions = [{ value: 0, label: "Limitsiz" }];

export const categories = [
  {
    id: "Sun Jun 27 2021",
    arr: [
      { id: "music0", name: "Music 0", date: "Sun Jun 27 2021" },
      { id: "video0", name: "Video 0", date: "Sun Jun 27 2021" },
      { id: "photos0", name: "Photos 0", date: "Sun Jun 27 2021" },
    ],
  },

  {
    id: "Sun Jun 28 2021",
    arr: [
      { id: "music1", name: "Music 1", date: "Sun Jun 28 2021" },
      { id: "video1", name: "Video 1", date: "Sun Jun 28 2021" },
      { id: "photos1", name: "Photos 1", date: "Sun Jun 28 2021" },
    ],
  },

  {
    id: "Sun Jun 29 2021",
    arr: [
      { id: "music2", name: "Music 2", date: "Sun Jun 29 2021" },
      { id: "video2", name: "Video 2", date: "Sun Jun 29 2021" },
      { id: "photos2", name: "Photos 2", date: "Sun Jun 29 2021" },
    ],
  },
];

export const workOrderRelationEnum = {
  related: 1,
  parent: 2,
  child: 3,
};

export const workOrderRelationOptions = [
  { value: workOrderRelationEnum.related, label: "related" },
  { value: workOrderRelationEnum.parent, label: "parent" },
  { value: workOrderRelationEnum.child, label: "child" },
];

export const workOrderTypeEnum = {
  request: 1,
  event: 2,
  problem: 3,
  change: 4,
  findingAndSuggestions: 5,
  dif: 6,
};

export const workOrderTypeOptions = [
  { value: workOrderTypeEnum.request, label: "Request" },
  //{ value: workOrderTypeEnum.event, label: "Event" },
  { value: workOrderTypeEnum.problem, label: "Problem" },
  { value: workOrderTypeEnum.change, label: "Change" },
  {
    value: workOrderTypeEnum.findingAndSuggestions,
    label: "FindingAndSuggestions",
  },
  { value: workOrderTypeEnum.dif, label: "DIF" },
];

export const workOrderStatusEnum = {
  open: 1, // Açık
  onHold: 2, // Beklemede
  solutionWasRejected: 3, // Çözüm Reddedildi
  resolved: 4, // Çözümlendi
  closedWithoutResolution: 5, // Çözümlenmeden Kapatıldı
  cancelled: 6, // İptal
  closed: 7, // Kapatıldı
  passive: 8, // Pasif
  denied: 9, // Reddedildi
  workingOnIt: 10, // Üzerinde Çalışılıyor
};

export const workOrderStatusOptions = [
  { value: workOrderStatusEnum.open, label: "open" },
  { value: workOrderStatusEnum.onHold, label: "on_hold" },
  {
    value: workOrderStatusEnum.solutionWasRejected,
    label: "solution_rejected",
  },
  { value: workOrderStatusEnum.resolved, label: "resolved" },
  {
    value: workOrderStatusEnum.closedWithoutResolution,
    label: "closed_without_resolution",
  },
  {
    value: workOrderStatusEnum.cancelled,
    label: "cancelled",
  },
  {
    value: workOrderStatusEnum.closed,
    label: "closed",
  },
  {
    value: workOrderStatusEnum.passive,
    label: "passive",
  },
  {
    value: workOrderStatusEnum.denied,
    label: "denied",
  },
  {
    value: workOrderStatusEnum.workingOnIt,
    label: "working_on_it",
  },
];

export const actionFieldOptions = [
  { value: 1, label: "single_customer" },
  { value: 2, label: "more_than_one_customer" },
  { value: 3, label: "all_customers" },
];

export const groupOptions = [
  {
    label: "group_1",
    value: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  },
  { label: "group_2", value: "3fa85f64-5717-4562-b3fc-2c963f66afa6" },
  { label: "group_3", value: "3fa85f64-5717-4562-b3fc-2c963f66afa6" },
];

export const priorityOptions = [
  { value: 1, label: "normal" },
  { value: 2, label: "important" },
  { value: 3, label: "critical" },
];
export const documentCategoryOptions = [
  { value: 1, label: "General" },
  { value: 2, label: "Secret" },
  { value: 3, label: "SpecialForCustomer" },
];
export const documentFileCategoryOptions = [
  { value: 1, label: "Sözleşme" },
  { value: 2, label: "Yetki Belgesi" },
  { value: 3, label: "Faaliyet Belgesi" },
  { value: 4, label: "Kimlik" },
];

export const taxFreeReasonOptions = [
  { value: 1, label: "Hizmet İhracatı" },
  { value: 2, label: "Sağlık,çevre ve sosyal yardım amaçlı işlemler" },
  { value: 3, label: "Diğer İstisnalar" },
];
export const notifyMonthOptions = [
  { value: 1, label: "6 Ay Önce" },
  { value: 2, label: "3 Ay Önce" },
  { value: 3, label: "1 Ay Önce" },
];
export const relatedUnitOptions = [
  { value: 1, label: "Hukuk Regulasyonlar" },
  { value: 2, label: "Teknoloji Direktorlüğü" },
  { value: 3, label: "IK" },
  { value: 4, label: "Teknik Operasyon" },
];
export const contractTypeOptions = [
  { value: 1, label: "Lisans Sözleşmeleri" },
  { value: 2, label: "Paket Sözleşmesi" },
  { value: 3, label: "Kapasite Sözleşmesi" },
];
export const groupRemindedOptions = [
  { value: 1, label: "isnet_kule@is.net.tr" },
  { value: 2, label: "musteri.hizmetleri@is.net.tr" },
];
export const numberOfRenewalsOptions = [
  { value: 1, label: "Tek Seferlik" },
  { value: 2, label: "İki kez" },
  { value: 3, label: "üç kez" },
  { value: 4, label: "Dört kez" },
  { value: 5, label: "Beş kez" },
];
export const refreshPeriodOptions = [
  { value: 1, label: "Altı(6) Ay" },
  { value: 2, label: "Yirmi dört (24) Ay" },
  { value: 3, label: "Otuz altı (36) Ay" },
  { value: 4, label: "Kırk sekiz (48 ) Ay" },
  { value: 5, label: "Altmış (60) Ay" },
];
export const startingCriteriaOptions = [
  { value: 1, label: "İmza Günü" },
  { value: 2, label: "Hizmet Başlangıç Tarihi" },
  { value: 3, label: "Özel Gün" },
];
export const serviceOptions = [
  { value: 1, label: "Sözleşme" },
  { value: 2, label: "Yetki Belgesi" },
  { value: 3, label: "Faaliyet Belgesi" },
  { value: 4, label: "Kimlik" },
];
//activities page customer options :)
export const customerOptions = [
  { value: "3fa85f64-5717-4562-b3fc-2c963f66afa6", label: "Customer 1" },
  { value: "3fa85f64-5717-4562-b3fc-2c963f66afa6", label: "Customer 2" },
];
//activities page customer options :)
export const activityReasonOptions = [
  { value: "making_appointment", label: "making_appointment" },
  { value: "opportunity", label: "opportunity" },
  { value: "bid", label: "bid" },
  { value: "tracking", label: "tracking" },
  { value: "campaing", label: "campaing" },
  { value: "order", label: "order" },
  { value: "invoice", label: "invoice" },
  { value: "product_service_request", label: "product_service_request" },
  { value: "issue_problem_complaint", label: "issue_problem_complaint" },
  { value: "post_survey_interview", label: "post_survey_interview" },
  { value: "information_support", label: "information_support" },
];
export const activityTypeOptions = [
  { value: "visit", label: "visit" },
  { value: "phone_call", label: "phone_call" },
  { value: "e_mail", label: "e_mail" },
  { value: "meeting", label: "meeting" },
  { value: "event_meeting", label: "event_meeting" },
  { value: "meal", label: "meal" },
  { value: "sms_instant_messsage", label: "sms_instant_messsage" },
];
export const activityResultOptions = [
  { value: "meet_again", label: "meet_again" },
  { value: "meeting_scheduled", label: "meeting_scheduled" },
  { value: "information_given", label: "information_given" },
  { value: "problem_solved", label: "problem_solved" },
  { value: "offer_submitted", label: "offer_submitted" },
  { value: "not_interested", label: "not_interested" },
  { value: "could_not_meet", label: "could_not_meet" },
  { value: "canceled_denied", label: "canceled_denied" },
];
export const activityServicesOptions = [
  { value: 1, label: "İşte Güvenlik" },
  { value: 2, label: "İşteHotspot" },
];
export const addressTypesOptions = [
  { value: 1, label: "Merkez/Genel Müdürlük" },
  { value: 2, label: "Şube/Genel Müdürlük" },
  { value: 3, label: "Mağaza İStasyon" },
  { value: 4, label: "Pop Adresi" },
  { value: 5, label: "Diğer" },
];
export const lucaTopicOptions = [
  { value: 1, label: "Toplu Cari Silme İşlemleri" },
  { value: 2, label: "Excel ile CAri Kart Aktarımı" },
];

export const supplierEnum = {
  general: 1,
  YSM: 2,
  VSAT: 3,
  e_commerce: 4,
};

export const supplierOptions = [
  { value: 1, label: "general" },
  { value: 2, label: "YSM" },
  { value: 3, label: "VSAT" },
  { value: 4, label: "e_commerce" },
];

export const customerStatusOptions = [
  { value: 1, label: "new" },
  { value: 2, label: "contact_future" },
  { value: 3, label: "contacted" },
  { value: 4, label: "not_contacted" },
];

export const sectorOptions = [
  { value: 1, label: "finance_banking" },
  { value: 2, label: "	insurance " },
];

export const partnerLevelId = [
  { value: 1, label: "distributor" },
  { value: 2, label: "main" },
  { value: 3, label: "seller" },
  { value: 4, label: "sub" },
];

export const titleOptions = [
  { value: 1, label: "Teknik Sorumlu" },
  { value: 2, label: "Diğer" },
  { value: 3, label: "Daire Baskanı" },
  { value: 4, label: "Yönetici" },
  { value: 5, label: "Bilgi İslem Müdürü" },
  { value: 6, label: "İs Geliştirme Direktörü" },
  { value: 7, label: "Satın Alma Müdürü" },
  { value: 8, label: "BilgiIslemDirektoru" },
  { value: 9, label: "SatinAlmaYetkilisi" },
  { value: 10, label: "Basvuru Yapan" },
  { value: 11, label: "Müdür" },
  { value: 12, label: "Direktör" },
  { value: 13, label: "Yetkili Uzman" },
  { value: 14, label: "Üst Düzey Yönetici" },
  { value: 15, label: "Satın alma Uzmanı" },
  { value: 16, label: "İs Geliştirme Uzmanı" },
  { value: 17, label: "Şirket Temsilcisi" },
  { value: 18, label: "Bilgi İşlem Uzmanı" },
  { value: 19, label: "Bölüm Birim Magaza Sorumlusu" },
  { value: 20, label: "Finans Yetkilisi" },
  { value: 21, label: "Bilgi İşlem Daire Baskani" },
  { value: 22, label: "İs Geliştirme Müdürü" },
  { value: 23, label: "İş Gelistirme Daire Baskanı" },
  { value: 24, label: "Satin alma Daire Baskanı" },
  { value: 25, label: "Hesap Yöneticisi" },
  { value: 26, label: "Satin alma Direktörü" },
];

export const nationEnum = {
  turkey: 1,
  cyprus: 2,
};

export const nationOptions = [
  { value: 1, label: "turkey" },
  { value: 2, label: "cyprus" },
];

export const identityCardEnum = {
  tc_new_identity: 1,
  tc_identity: 2,
  tc_passport: 3,
  tc_driver_license: 4,
};

export const identityOptions = [
  { value: 1, label: "tc_new_identity" },
  { value: 2, label: "tc_identity" },
  { value: 3, label: "tc_passport" },
  { value: 4, label: "tc_driver_license" },
];

export const socialStatusOptions = [
  { value: 1, label: "gazi" },
  { value: 2, label: "sehit_yakini" },
  { value: 3, label: "engelli" },
];

export const genderOptions = [
  { value: 1, label: "men" },
  { value: 2, label: "women" },
];

export const communicationTypeOptions = [
  { value: 1, label: "e-mail" },
  { value: 2, label: "mobile" },
  { value: 3, label: "sms" },
  { value: 4, label: "phone" },
];

export const communicationTypeEnum = {
  e_mail: 1,
  mobile: 2,
  sms: 3,
  phone: 4,
};

export const customerTypeEnum = {
  lead: 1,
  real: 2,
};

export const customerTypeOptions = [
  {
    value: customerTypeEnum.lead,
    label: "lead",
  },
  {
    value: customerTypeEnum.real,
    label: "real",
  },
];

export const customerKindEnum = {
  indivual: 1,
  corporate: 2,
  soleProprietorship: 3,
};

export const customerKindOptions = [
  {
    value: customerKindEnum.indivual,
    label: "indivual",
  },
  {
    value: customerKindEnum.corporate,
    label: "corporate",
  },
  {
    value: customerKindEnum.soleProprietorship,
    label: "soleProprietorship",
  },
];
export const orderStatusEnum = {
  preparing: 1,
  waiting: 2,
  completed: 3,
  cancelled: 4,
  workingOnIt: 5,
};

export const orderLineStatus = {
  UnderSetup: 1,
  Open: 2,
  Pending: 3,
  Revised: 4,
  Closed: 5,
};

export const orderStatusOptions = [
  {
    value: orderStatusEnum.preparing,
    label: "preparing",
  },
  {
    value: orderStatusEnum.waiting,
    label: "waiting",
  },
  {
    value: orderStatusEnum.completed,
    label: "completed",
  },
  {
    value: orderStatusEnum.cancelled,
    label: "cancel",
  },
  {
    value: orderStatusEnum.workingOnIt,
    label: "working_on",
  },
];

export const customerAcceptanceOptions = [
  {
    value: 1,
    label: "ZeroPercentLostBid",
  },
  {
    value: 2,
    label: "TenPercentOpportunitySolution",
  },
  {
    value: 3,
    label: "IOfferedThirtyPercent",
  },
  {
    value: 4,
    label: "IMadeAFiftyPercentRevisedOffer",
  },
  {
    value: 5,
    label: "SeventyPercentProposalEvaluatedbyManagement",
  },
  {
    value: 6,
    label: "NinetyPercentOfferConfirmed",
  },
];

export const acceptanceOptions = [
  {
    value: 1,
    label: "proposal_lose",
  },
  {
    value: 2,
    label: "proposal_oppurtunity",
  },
  {
    value: 3,
    label: "proposal_made",
  },
  {
    value: 4,
    label: "proposal_made_revised",
  },
  {
    value: 5,
    label: "proposal_in_management",
  },
  {
    value: 6,
    label: "proposal_approved",
  },
];

export const acceptanceOptionsCreate = [
  {
    value: 2,
    label: "proposal_oppurtunity",
  },
  {
    value: 3,
    label: "proposal_made",
  },
  {
    value: 4,
    label: "proposal_made_revised",
  },
  {
    value: 5,
    label: "proposal_in_management",
  },
  {
    value: 6,
    label: "proposal_approved",
  },
];

export const proposalStatusEnum = {
  draft: 1,
  ready: 2,
  working_on: 3,
  presented: 4,
  won: 5,
  lose: 6,
  expired: 7,
  revised: 8,
};

export const proposalStatusOptions = [
  {
    value: proposalStatusEnum.draft,
    label: "Draft",
  },
  {
    value: proposalStatusEnum.ready,
    label: "Ready",
  },
  {
    value: proposalStatusEnum.working_on,
    label: "WorkingOnIt",
  },
  {
    value: proposalStatusEnum.presented,
    label: "Presented",
  },
  {
    value: proposalStatusEnum.won,
    label: "Won",
  },
  {
    value: proposalStatusEnum.lose,
    label: "Lost",
  },
  {
    value: proposalStatusEnum.expired,
    label: "Expired",
  },
  {
    value: proposalStatusEnum.revised,
    label: "Revised",
  },
];

export const productTypeOptions = [
  {
    value: 1,
    label: "firewall",
  },
  {
    value: 2,
    label: "hotspot",
  },
];

export const productVariantOptions = [
  {
    value: 1,
    label: "firewall_setup",
  },
  {
    value: 2,
    label: "firewall_monthly_care",
  },
  { value: 3, label: "hotspot_25_user" },
];

export const unitOptions = [
  {
    value: 1,
    label: "quantity",
  },
  {
    value: 2,
    label: "gram",
  },
  { value: 3, label: "gb" },
];

export const downTimeEnum = {
  noInterrupt: 1,
  lessThan15m: 2,
  moreThan15m: 3,
};

export const downTimeOptions = [
  {
    id: downTimeEnum.noInterrupt,
    name: "NoInterruptionsExpected",
  },
  {
    id: downTimeEnum.lessThan15m,
    name: "LessThan15Minutes",
  },
  {
    id: downTimeEnum.moreThan15m,
    name: "MoreThan15Minutes",
  },
];

export const changeTypeEnum = {
  urgent: 1,
  eInvoice: 2,
  system: 3,
  sla: 4,
  version: 5,
  high: 6,
};

export const changeTypeOptions = [
  {
    id: changeTypeEnum.urgent,
    name: "UrgentChanges",
  },
  {
    id: changeTypeEnum.eInvoice,
    name: "EInvoiceApplicationChange",
  },
  {
    id: changeTypeEnum.system,
    name: "SystemAndInfrastructureChange",
  },
  {
    id: changeTypeEnum.sla,
    name: "SLAChanges",
  },
  {
    id: changeTypeEnum.version,
    name: "Version",
  },
  {
    id: changeTypeEnum.high,
    name: "HighChanges",
  },
];

export const closureTypeEnum = {
  fixed: 1,
  riskAccepted: 2,
  other: 3,
  rootReasonAnalysis: 4,
};

export const closureTypeOptions = [
  {
    id: closureTypeEnum.fixed,
    name: "TheTroubleHasBeenFixed",
  },
  {
    id: closureTypeEnum.riskAccepted,
    name: "RiskAccepted",
  },
  {
    id: closureTypeEnum.other,
    name: "Other",
  },
  {
    id: closureTypeEnum.rootReasonAnalysis,
    name: "RootReasonAnalysis",
  },
];

export const ActionFieldEnum = {
  SingleCustomer: 1, // Tek Müşteri
  MoreThanOneCustomer: 2, // Birden fazla müşteri
  AllCustomer: 3, // Tüm müşteriler
  FinancialImprovement: 5, // Finansal İyileştirme
  CustomerSatisfaction: 6, // Müşteri Memnuniyeti
  ComplianceWithTheLaw: 7, // Yasaya Uyum
  InfrastructureImprovement: 8, // Alt Yapı İyileştirme
};

export const NotificationEnum = {
  debt: 1,
  invoice: 2,
  technical: 3,
  marketingAndGeneralAnnouncement: 4,
};

export const locationTypeEnum = {
  city: 1,
  town: 2,
  townShip: 3,
  village: 4,
  district: 5,
  street: 6,
  building: 7,
  door: 8,
  country: 0,
};

export const roleEnum = {
  admin_manager: 1,
  supervisor: 2,
  manager: 3,
  user: 4,
};

export const roleOptions = [
  { value: roleEnum.admin_manager, label: "admin_manager" },
  { value: roleEnum.supervisor, label: "supervisor" },
  { value: roleEnum.manager, label: "manager" },
  { value: roleEnum.user, label: "user" },
];

export const submissionMethodIdOptions = [{ value: 1, label: "electronik" }];

export const termsOfPaymentOptions = [
  { value: 5, label: "5_day_delay" },
  { value: 10, label: "10_day_delay" },
  { value: 15, label: "15_day_delay" },
  { value: 20, label: "20_day_delay" },
  { value: 25, label: "25_day_delay" },
  { value: 30, label: "30_day_delay" },
  { value: 60, label: "60_day_delay" },
];

export const invoiceTypeOptions = [
  {
    value: 1,
    label: "sale",
  },
  {
    value: 2,
    label: "cancel",
  },
];

export const typeIdOptions = [
  { value: 1, label: "sale" },
  { value: 1, label: "sale" },
];

export const invoiceStatusOptions = [
  { value: 1, label: "paid" },
  { value: 2, label: "partlyPaid" },
  { value: 3, label: "notPaid" },
];

export const exchangeRateUnitId = [
  { value: 1, label: "activeRate" },
  { value: 2, label: "fixedRate" },
];

export const booleanOptions = [
  { value: true, label: "true" },
  { value: false, label: "false" },
];

export const variantStatusEnum = {
  active: 1,
  passive: 2,
  notForSale: 3,
};

export const variantStatusOptions = [
  { value: variantStatusEnum.active, label: "active" },
  { value: variantStatusEnum.passive, label: "passive" },
  { value: variantStatusEnum.notForSale, label: "notForSale" },
];

export const proposalTypeEnum = {
  newCustomer: 1,
  currentCustomer: 2,
};

export const proposalTypeOptions = [
  { value: proposalTypeEnum.newCustomer, label: "new_customer" },
  { value: proposalTypeEnum.currentCustomer, label: "current_customer" },
];

export const CustomerHasOwnerOptions = [
  { value: CustomerHasOwnerEnum.all, label: "has_owner_all" },
  { value: CustomerHasOwnerEnum.hasNotOwner, label: "hasnt_owner" },
  { value: CustomerHasOwnerEnum.hasOwner, label: "has_owner" },
];

export const SignitureTypeOptions = [
  { value: SignitureTypeEnum.ElectronicIdentity, label: "ElectronicIdentity" },
  { value: SignitureTypeEnum.ESignature, label: "ESignature" },
];

export const legalPermissionStatusEnum = {
  waiting: 1,
  approved: 2,
  denied: 3,
};

export const legalPermissionChanelEnum = {
  sms: 2,
  email: 1,
};

export const legalPermissionTypeEnum = {
  kvkk: 1,
  pazarlama: 2,
  kvkkPazarlama: 3,
};

export const customerActiveOptions = [
  { value: true, label: "active_customer" },
  { value: false, label: "passive_customer" },
];

export const AdSourceGroupOptions = [
  { value: AdSourceGroupEnum.OnlineChannel, label: "online_channel" },
  { value: AdSourceGroupEnum.BusinessPartner, label: "business_partner" },
];

export enum CustomerFilterType {
  Active = 0,
  Passive,
  All,
}

export const customerFilterOptions = [
  { value: CustomerFilterType.Active, label: "active_customers" },
  { value: CustomerFilterType.Passive, label: "passive_customers" },
  { value: CustomerFilterType.All, label: "all_customers" },
];

export const customerOwnerGrupEnum = {
  e_donusum: "39eb94dc-2ed9-43c1-b523-19b1ceffe75b",
  kurumsal_satis: "22849c77-7513-42b1-99da-36d4c9208c79",
  idari_isler: "342cb3aa-93a4-4c2b-b9f8-39977e60ad06",
  satis_oncesi_muhendislik: "ecf11e0a-7a9c-4dfd-8ef6-bdc293fdc884",
  yazilimGelistirme: "41C985D9-4500-44C4-A23D-691A22D51F44",
  yonetim: "10f65ad6-e076-436d-8a64-1492bb3fe2fc",
  satis_direktorlugu: "1133a00c-1e3f-4be3-a6c5-ae878fd3ae33",
};

export const contactCommunicationDefaults = [
  {
    value: "",
    description: "",
    communicationTypeId: 1,
    contactCommunicationPermission: {
      debt: false,
      invoice: false,
      marketingAndGeneralAnnouncement: false,
      technical: false,
    },
  },
  {
    value: "",
    description: "",
    communicationTypeId: 2,
    contactCommunicationPermission: {
      debt: false,
      invoice: false,
      marketingAndGeneralAnnouncement: false,
      technical: false,
    },
  },
];

export const PasswordFrequencyOptions = [
  { value: PasswordFrequencyEnum.oneMonth, label: "one_month" },
  { value: PasswordFrequencyEnum.threeMonths, label: "three_months" },
  { value: PasswordFrequencyEnum.sixMonths, label: "six_months" },
];

export enum Role {
  AdminManager = "admin",
  Supervisor = "supervisor",
  Manager = "manager",
  User = "user",
}

export const paymentTypeOptions = [
  { value: paymentTypeEnum.new, label: i18n.t("tabs.service.new") },
  { value: paymentTypeEnum.churn, label: i18n.t("tabs.service.churn") },
];
export const paymentVoiceTypeOptions = [
  { value: paymentVoiceTypeEnum.thk, label: "THK" },
  { value: paymentVoiceTypeEnum.voip, label: "VOIP" },
  { value: paymentVoiceTypeEnum.sanal_santral, label: "Sanal Santral" },
];

export const serviceTypeOptions = [
  { value: serviceTypeEnum.pstn, label: "PSTN" },
  { value: serviceTypeEnum.pri, label: "PRI" },
  { value: serviceTypeEnum.bri, label: "BRI" },
];

export const serviceConnectTypeOptions = [
  { value: serviceConnectTypeEnum.xdsl, label: "XDSL" },
];

export const newTypeOptions = [
  { value: newTypeEnum.lean_internet, label: "Yalın İnternet", id: 100 },
  {
    value: newTypeEnum.lean_internet_fiber,
    label: "Yalın İnternet Fiber ( FTTX )",
    id: 100,
  },
  { value: newTypeEnum.internet, label: "İnternet", id: 110 },
  { value: newTypeEnum.inter_fttx, label: "İnternet FTTX", id: 110 },
];

export const voiceProductTypeOptions = [
  { value: paymentVoiceTypeEnum.thk, label: "THK" },
  {
    value: paymentVoiceTypeEnum.voip,
    label: "VOIP & Ara bağlantı",
  },
  { value: paymentVoiceTypeEnum.sanal_santral, label: "Sanal Santral" },
];

export const lineOptions = [
  { value: lineEnum.fixed_line, label: "Sabit Hat" },
  { value: lineEnum.lean_line, label: "Yalın Hat" },
];

export const termsOfPaymentInvoiceGroupOptions = [
  { value: termsOfPaymentInvoiceGroupEnum.TenDayTerm, label: "ten_day_term" },
  {
    value: termsOfPaymentInvoiceGroupEnum.FifteenDayTerm,
    label: "fifteen_day_term",
  },
  {
    value: termsOfPaymentInvoiceGroupEnum.TwentyDayTerm,
    label: "twenty_day_term",
  },
  {
    value: termsOfPaymentInvoiceGroupEnum.ThirtyDayTerm,
    label: "thirty_day_term",
  },
  {
    value: termsOfPaymentInvoiceGroupEnum.FortyFiveDayTerm,
    label: "forty_five_day_term",
  },
  {
    value: termsOfPaymentInvoiceGroupEnum.SixtyDayTerm,
    label: "sixty_day_term",
  },
  {
    value: termsOfPaymentInvoiceGroupEnum.NinetyDayTerm,
    label: "ninety_day_term",
  },
  { value: termsOfPaymentInvoiceGroupEnum.CashPayment, label: "cash_payment" },
  {
    value: termsOfPaymentInvoiceGroupEnum.ExchangeRateDifference,
    label: "exchange_rate_difference",
  },
];

export const invoicePeriodOptions = [
  { value: invoicePeriodEnum.forOnce, label: "Tek Seferlik" },
  { value: invoicePeriodEnum.monthly, label: "Aylık" },
  { value: invoicePeriodEnum.three_months, label: "3 Aylık" },
  { value: invoicePeriodEnum.twelve_months, label: "12 Aylık" },
  { value: invoicePeriodEnum.twenty_four_months, label: "24 Aylık" },
  { value: invoicePeriodEnum.thirty_six_months, label: "36 Aylık" },
  { value: invoicePeriodEnum.forty_eight_months, label: "48 Aylık" },
  { value: invoicePeriodEnum.sixty_months, label: "60 Aylık" },
];

export const exchangeRateUnitIdOptions = [
  { value: ExchangeRateUnitEnum.ActiveRate, label: "activeRate" },
  { value: ExchangeRateUnitEnum.FixedRate, label: "fixedRate" },
];

export const currencyOptions = [
  { value: currencyEnum.TRY, label: "TRY" },
  { value: currencyEnum.USD, label: "USD" },
  { value: currencyEnum.EUR, label: "EUR" },
  { value: currencyEnum.GBP, label: "GBP" },
];

export const ddTechOptions = [
  { value: DDTechTypeEnum.Template, label: "Template" },
  { value: DDTechTypeEnum.Document, label: "Document" },
];

export const infrastructureOptions = [
  { value: InfrastructureEnum.Pstn, label: "Pstn ile Sorgulama" },
  { value: InfrastructureEnum.Xdsl, label: "Xdsl ile Sorgulama" },
];

export const customerCommunicationTypeEnum = {
  publicEmail: 1,
  mobile: 2,
  technicalEmail: 3,
};
